export enum MembershipBadgeType {
  ANNUAL_LEVEL_ONE = 'annual-level-one.svg',
  ANNUAL_LEVEL_TWO = 'annual-level-two.svg',
  ANNUAL_LEVEL_THREE = 'annual-level-three.svg',
  ANNUAL_LEVEL_FOUR = 'annual-level-four.svg',
  ANNUAL_LEVEL_FIVE = 'annual-level-five.svg',
  MONTHLY_LEVEL_ONE = 'monthly-level-one.svg',
  MONTHLY_LEVEL_TWO = 'monthly-level-two.svg',
  MONTHLY_LEVEL_THREE = 'monthly-level-three.svg',
  MONTHLY_LEVEL_FOUR = 'monthly-level-four.svg',
  MONTHLY_LEVEL_FIVE = 'monthly-level-five.svg',
}
